import { render, staticRenderFns } from "./vita.vue?vue&type=template&id=97c8fde4&scoped=true"
import script from "./vita.vue?vue&type=script&lang=js"
export * from "./vita.vue?vue&type=script&lang=js"
import style0 from "./vita.vue?vue&type=style&index=0&id=97c8fde4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8fde4",
  null
  
)

export default component.exports